import { render, staticRenderFns } from "./wish.vue?vue&type=template&id=3158723d"
import script from "./wish.vue?vue&type=script&lang=ts"
export * from "./wish.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports